import * as R from 'ramda';
import { ActionType } from '../core/redux/actionType';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../core/api/module';
import { Endpoints } from '../core/api/endpoints';


const KEY_ACTION = ActionType.LoadConfigRequest;
const ACTIONS    = [
  ActionType.LoadConfigRequest,
  ActionType.LoadConfigResponse,
  ActionType.LoadConfigError,
];


type Payload = string;


/**
 * Dispatch this action to load the app's configuration
 */
export const loadConfigAction = () => makeApiAction<Payload>({
  method:   'GET',
  endpoint: Endpoints.Config,
  headers:  { 'accept': 'application/json' },
  types:    makeRsaaTypes<Payload>(ACTIONS),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('config', JSON.parse(payload || ''), successState);
};


export const loadConfigReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
